/* YouTube Player */

function loadVideo() {
    (function loadYoutubeIFrameApiScript() {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";

        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        tag.onload = setupPlayer;
    })();

    let player = null;

    function setupPlayer() {

        window.YT.ready(function () {
            $('.js-video').each(function () {

                const $video = $(this);
                var videoId = $video.data('youtube-id');

                player = new window.YT.Player($(this).attr('id'), {
                    videoId: videoId,
                    events: {
                        onReady: onPlayerReady,
                        onStateChange: onPlayerStateChange
                    }
                });
            });
        });
    }

    function onPlayerReady(event) {
        player.mute();

        //Start youtube video on button click
        $('.js-video-play').click(function (e) {
            e.preventDefault();

            $(this).parents('.video').addClass('is-playing');

            event.target.playVideo();
        });
    }

    function onPlayerStateChange(event) {
        $(this).parents('.video').removeClass('is-playing');
    }
}


if (document.readyState !== "loading") {
    loadVideo();
} else {
    document.addEventListener("DOMContentLoaded", function () {
        loadVideo();
    });
}
